import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/settings/characters')({
  component: SettingsCharactersLayout
})

function SettingsCharactersLayout() {
  return <Outlet />
}
